<template>
  <div>
    <vs-popup
        :title="
         'ویرایش '
        "
        :active.sync="showModal"
      >
    <div class="mt-5 flex gap-5 mb-10">
      <div class="vx-col lg:w-2/3 w-full mt-1">
        <label class="vs-select--label">{{ $t("Product") }}</label>
        <treeselect
          name="agent"
          :multiple="false"
          :placeholder="$t('SearchProduct')"
          :async="true"
          :load-options="loadOptionsProduct"
          v-validate="'required'"
          class="search-input"
          ref="product"
          @select="onActualProductSelected($event)"
        />
      </div>
      <div>
        <vs-input
                class="inputx "
                v-model="price"
                name="bPrice"
                :label="$t('Fee')"
                v-validate="'required'"
              />      </div>
      <vs-button
        class="btn-drop vs-component vs-button bg_l_green bg-danger mt-6"
        color="success"
        icon="add"
        @click.prevent="AddAccounts(model)"
      ></vs-button>
    </div>
    <table
      v-if="selectedProducts.length > 0"
      class="basic-tbl mt-10"
      id="colored-table"
    >
      <thead>
        <tr>
          <th>{{ $t("Product") }}</th>
          <th>{{ $t("Price") }}</th>
          <th>{{ $t("Action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(account, i) in selectedProducts">
          <!-- <td style="width: 10%">
                  <span v-if="account.accountType == 1">گروه حساب</span>
                  <span v-if="account.accountType == 2">حساب کل</span>
                  <span v-if="account.accountType == 3">حساب معین</span>
                  <span v-if="account.accountType == 4">حساب تفضیلی</span>
                  <span v-if="account.accountType == 5">حساب شناوری</span>
                </td> -->
          <td>
            <span>
              {{ account.label ? account.label : "" }}
            </span>
          </td>
          <td>
            <span>
              {{ account.price ? formatPrice(account.price) : "" }}
            </span>
          </td>
          <td style="width: 10%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="deleteAccount(i)"
              class="d-inline remove-btn flex-shrink-0"
            ></vs-button>
          </td>
        </tr>
      </tbody>
    </table>
    <vs-button
      v-if="selectedProducts.length > 0"
      v-has-permission="'AssignContractProductInfo'"
      type="filled"
      class="float-right mb-4 mt-12"
      @click.prevent="submitForm"
      >{{ $t("Save") }}</vs-button
    >
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  name: "saleManagement_Contract_Management_BaseSalePricePopup",
  components: {
    DataGrid,
    Treeselect,
  },
  props: {
    show: { default: false },
    contractId:{type:Number},
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      editMode: false,
      disabled: false,
      selectedProducts: [],
      price:'',
      product:null,
    };
  },

  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createBaseSalePrice: "baseSalePrice/create",
      searchProduct: "sale/searchContractProductsList",
      updateBaseSalePrice: "sale/updateBaseSalePrice",

    }),
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    AddAccounts(model) {
      if (model.price && model.itemCode) {
        var index = this.selectedProducts.findIndex(
          (x) => x.itemCode === model.itemCode
        );
        if (index === -1) {
          this.selectedProducts.push(model);
          this.model = {};
          this.product = null;
          this.price=null
        } else {
          this.$swal({
            position: "center-center",
            type: "error",
            text: "کالا انتخابی تکراری می باشد!",
            showConfirmButton: false,
            timer: 8000,
          });
        }
      }
    },
    deleteAccount(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.selectedProducts.splice(index, 1);
        }
      });
    },
    submitForm() {
      var payload = {
        contractId: this.contractId,
        baseSalePriceItemsCommand: this.selectedProducts,
      };
      this.updateBaseSalePrice(payload).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("close");
      });
    },
    onActualProductSelected(data) {
      this.model.id = data.itemCode;
      this.model.itemCode = data.itemCode;
      this.model.label = data.label;
      this.product = null;

    },
    loadOptionsProduct({ searchQuery, callback }) {
      this.searchQueryProductNew = searchQuery;
      this.searchQueryProductOld = this.searchQueryProductNew;
      setTimeout(() => {
        this.searchQueryProductNew = searchQuery;
        if (this.searchQueryProductOld == this.searchQueryProductNew) {
          this.searchProduct({id:this.contractId,name:searchQuery}).then((response) => {
            const options = [];
            response.data.forEach(function (element) {
              options.push({
                id: element.productId,
                  label: element.persianName,
                  itemCode:element.itemCode,
                  name: element.productName,
              });
            });
            callback(null, options);
          });
        }
      }, 2000);
    },
  },
  watch: {
    price(value) {
      if (value) {
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.price = n.toLocaleString();
        this.model.price = this.price.replace(/,/g, "");
      } else {
        this.price = null;
        this.model.price = null;
      }
    },
    show() {
      if (this.show) {
        if (this.model.id) {
          // edit mode
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      }
    },
  },
};
</script>

<style>
.con-vs-popup .vs-popup{
  width: 1300px !important;
  min-height: 500px !important;
}
.vs-popup--content{
  min-height: 500px !important;

}
</style>
